import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// dinamically create pages routes
import pagesRoutes from "routes/pages.jsx";

import bgImage from "assets/img/full-screen-image-3.jpg";
import HpmHeader from "../../components/Header/HpmHeader";
import ClaimPage from "../../views/Pages/ClaimPage";

class Pages extends Component {
  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  componentDidMount() {}
  render() {
    return (
      <div>
        <HpmHeader />
        <div className="wrapper wrapper-full-page">
          <div
            className={"full-page login-page"}
            data-color="black"
            data-image={bgImage}
          >
            <div className="content">
              <ClaimPage />
            </div>
            <div
              className="full-page-background"
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;



// WEBPACK FOOTER //
// ./src/layouts/Pages/Pages.jsx